


import {disconnectSocket} from '../../app/socketService';

import React from 'react';

// import { useAuth0 } from '@auth0/auth0-react';
import { useAuth } from '../../app/useAuth'; 



const LogoutButton = () => {

	// const { logout } = useAuth0();
	const { logout } = useAuth(); 

	const handleLogout = ({ socketRef }) => {

		disconnectSocket();

		const returnToUrl = window.location.origin + '/logged_out';
		// const returnToUrl = 'http://localhost:3003/logged_out';
		// const returnToUrl = window.location.origin + '/logged-out';

		
		console.log('🔍 Current origin:', window.location.origin);
		console.log('🔍 Logout returnTo:', returnToUrl);

		console.log('we should be disconnected');

		localStorage.removeItem('access_token');
		localStorage.removeItem('refresh_token');
		sessionStorage.clear();

		// const isDev = window.location.port === '3005'; // Check if running on dev server
		// const returnToUrl = isDev
		// ? 'http://localhost:3005/logged_out'
		// : 'http://localhost:3004/logged_out';


		// logout({
		// 	returnTo: returnToUrl,
		// });

		logout({
			logoutParams: {
				returnTo: returnToUrl
			}
		});

		// logout({
		// 	returnTo: "http://localhost:3005/logged_out"
		// });
	};

	return (
		<button id="logout_button" style={{ fontSize: "60%" }} onClick={handleLogout}>
			Logout
		</button>
	);
};

export default LogoutButton;

